// src/plugins/vuetify.js

import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import '../assets/fontawesome/js/all.min'
import '@mdi/font/css/materialdesignicons.css'

Vue.use(Vuetify);

const opts = {
    theme: {
        options: {customProperties: true},
        themes: {
            light: {
                primary: '#998065',
                secondary: '#F2F2F2',
            }
        }
    },
};

export default new Vuetify(opts)
